export default {
    // PublishCaution.vue
    'Caution': 'Attention',
    'Someone is already using this channel.': 'Quelqu\'un utilise déjà ce canal.',
    'By clicking "Continue", the previous user will be disconnected.': 'En cliquant sur "Continuer", l\'utilisateur précédent sera déconnecté.',
    'Cancel': 'Annuler',
    'Continue': 'Continuer',
    
    // TalktoProducerController.vue
    'Talk to remote speakers': 'Parler aux Speakers distants',
    'TALK': 'PARLER',
    'All remote speakers': 'Tous les Speakers distants',
    'Talk to all remote speakers.': 'Parler à tous les Speakers distants.',
    'Talk to': 'Parler à',
    'Stop Talking': 'Arrêter de parler',
    
    // AudioDeviceConfig.vue
    'Configure microphone': 'Configurer le microphone',
    'Select microphone': 'Sélectionner un microphone',
    
    // SoundCapture.vue
    'TalkTo disconnected ! A new connection has been initialized from another browser': 'TalkTo déconnecté ! Une nouvelle connexion a été initialisée depuis un autre navigateur',
    
    // TalktoController.vue
    'PRODUCER': 'PRODUCTEUR'
}